import type { IconData } from '@stacksjs/iconify-core'

export const penNib: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M487.97 155.853a24.04 24.04 0 0 0-7-18.166L376.126 32.842a24 24 0 0 0-35.546 1.772l-89.936 109.922l-130.137 26.514a27.1 27.1 0 0 0-20.025 17.026L17.883 405.84a27.27 27.27 0 0 0 6.205 28.917l53.271 53.271a27.26 27.26 0 0 0 28.915 6.207l217.86-82.635a27.14 27.14 0 0 0 16.95-19.655l28.1-128.7L479.2 173.232a24.04 24.04 0 0 0 8.77-17.379m-177.6 226.741L97.807 463.222l-13.142-13.143l99.36-99.36a56.061 56.061 0 1 0-22.268-22.986l-99.72 99.72l-13.143-13.143l80.576-212.429l124.717-25.41l83.052 83.051ZM187.42 301.9a24 24 0 1 1 24 24a24 24 0 0 1-24-24m168.391-69.065L280.973 158l78.776-96.28l92.343 92.343Z\"/>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default penNib
